import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayoutService } from 'src/app/core/services/template/layout.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-mobile-warning',
  templateUrl: './mobile-warning.component.html',
  styleUrls: ['./mobile-warning.component.scss']
})
export class MobileWarningComponent implements OnInit, OnDestroy {
  isVisible = false;
  isMobile = false;
  private subscriptions = new Subscription();
  private readonly STORAGE_KEY = 'mobile_warning_dismissed';

  // Site administration screens migrated to the responsive 2026 kit. The
  // warning remains for legacy areas, including POS, until they are migrated.
  private readonly responsivePaths = [
    /^\/ecommerce\/dashboard(?:\/global-dashboard)?\/?$/,
    /^\/ecommerce\/dashboard\/dashboard\//,
    /^\/ecommerce\/products\/products-list\//,
    /^\/ecommerce\/products\/product-details\//,
    /^\/ecommerce\/products\/categories\/categories-list\//,
    /^\/ecommerce\/orders\/orders-list\//,
    /^\/ecommerce\/orders\/order-details\//,
    /^\/ecommerce\/shop-settings\/nav-settings\//
  ];

  constructor(private layoutService: LayoutService, private router: Router) { }

  ngOnInit(): void {
    this.subscriptions.add(this.layoutService.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.updateVisibility();
    }));
    this.subscriptions.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) this.updateVisibility();
    }));
    this.updateVisibility();
  }

  private updateVisibility(): void {
    const path = this.router.url.split('?')[0];
    const isResponsiveScreen = this.responsivePaths.some(pattern => pattern.test(path));
    const isDismissed = sessionStorage.getItem(this.STORAGE_KEY) === 'true';
    this.isVisible = this.isMobile && !isResponsiveScreen && !isDismissed;
  }

  dismiss(): void {
    this.isVisible = false;
    sessionStorage.setItem(this.STORAGE_KEY, 'true');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
